import React from 'react';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';

//Text fields
const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   textField: {
      marginTop: '8px',
      marginLeft: '8px',
      marginRight: '8px',
      width: '100%'
   },
   label: {
      marginLeft: '8px'
   },
   doc: {
      marginRight: theme.spacing(1.5)
   }
}));

const DocumentoDS = (props) => {
   const elementos = props.componentesProps;
   const {classes} = useStyles();

   return (
      <>
         <InputLabel htmlFor="grid-doc" className={classes.label}>
            {props.label}
         </InputLabel>
         <Grid id="grid-doc" container spacing={1} className={classes.doc}>
            {elementos.map((ele) => {
               const {estado, ...other} = ele;
               return (
                  <Grid item xs={4} key={ele.name}>
                     <TextField
                        value={estado}
                        {...other}
                        className={classes.textField}
                        onChange={props.handleChange}
                        disabled={props.disabled}
                        margin="normal"
                     />
                  </Grid>
               );
            })}
         </Grid>
      </>
   );
};

export default DocumentoDS;
